class VendmontDigitalConsent extends HTMLElement {
  connectedCallback() {
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.status = this.querySelector('[data-consent-status]');
    this.scope = this.closest('.cart-drawer__summary, .cart-page__summary') || this.parentElement;
    this.checkoutButton = this.scope?.querySelector('[name="checkout"]');
    this.acceleratedButtons = this.scope?.querySelector('.additional-checkout-buttons');

    if (!this.checkbox || !this.checkoutButton) return;

    this.checkbox.addEventListener('change', this.handleChange);
    this.checkoutButton.addEventListener('click', this.guardCheckout, true);
    this.applyState(this.checkbox.checked);
  }

  disconnectedCallback() {
    this.checkbox?.removeEventListener('change', this.handleChange);
    this.checkoutButton?.removeEventListener('click', this.guardCheckout, true);
  }

  handleChange = async () => {
    const checked = this.checkbox.checked;
    this.dataset.state = 'saving';
    this.checkbox.disabled = true;
    this.applyState(false);
    this.setStatus(this.dataset.savingText);

    const attributes = {
      vendmont_digital_supply_consent: checked ? 'yes' : '',
      vendmont_digital_supply_consent_at: checked ? new Date().toISOString() : ''
    };

    try {
      const response = await fetch(this.dataset.updateUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ attributes })
      });

      if (!response.ok) throw new Error(`Cart update failed with ${response.status}`);

      this.dataset.state = checked ? 'accepted' : 'required';
      this.applyState(checked);
      this.setStatus(checked ? this.dataset.savedText : this.dataset.requiredText);
    } catch {
      this.checkbox.checked = false;
      this.dataset.state = 'error';
      this.applyState(false);
      this.setStatus(this.dataset.errorText);
    } finally {
      this.checkbox.disabled = false;
    }
  };

  guardCheckout = (event) => {
    if (this.checkbox.checked && this.dataset.state === 'accepted') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    this.checkbox.focus();
    this.setStatus(this.dataset.requiredText);
  };

  applyState(accepted) {
    this.checkoutButton.disabled = !accepted;
    this.checkoutButton.setAttribute('aria-disabled', String(!accepted));

    if (this.acceleratedButtons) {
      this.acceleratedButtons.hidden = !accepted;
      this.acceleratedButtons.setAttribute('aria-hidden', String(!accepted));
    }
  }

  setStatus(message) {
    if (this.status) this.status.textContent = message || '';
  }
}

if (!customElements.get('vendmont-digital-consent')) {
  customElements.define('vendmont-digital-consent', VendmontDigitalConsent);
}
